import { render, staticRenderFns } from "./UploadFileIPT.vue?vue&type=template&id=2c7f45eb"
import script from "./UploadFileIPT.vue?vue&type=script&lang=js"
export * from "./UploadFileIPT.vue?vue&type=script&lang=js"
import style0 from "./UploadFileIPT.vue?vue&type=style&index=0&id=2c7f45eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports